<template lang='pug'>
  blue-layout( 
    v-else :user='user' 
    :account='account' 
    :biz='biz' 
    :style='style'
  )
    template( v-slot:default='props' )
      section#merchant
        bf-wrapper
          base-card.name
            bf-flex
              img.logo.flex-item( :src='biz.logo' )

              bf-flex.title.flex-item.column
                h5
                  span {{ biz.name }}

                template(v-if='status')
                  .availability.available(v-if='status.available') {{ $t(status.title) }}
                  .availability.not-available(v-else) {{ $t(status.title) }}

            .fav-btn.actionable(
              v-if='account.id && account.id != biz.user_id'
              :class='{ fav: favored }'
              @click='favor'
            )
              .icon
                fav-icon
              .text {{ $t('Click to Toggle') }} 
              .vip(v-if='vip=="VIP"')
                img(src='/ui/vip.svg')

          base-card.contact
            .address
              bf-flex
                span.icon
                  address-icon
                span.text {{ biz.address }}
            .web
              bf-flex
                span.icon
                  web-icon
                a( :href='biz.web' ).text {{ biz.web }}
            .phone
              bf-flex
                span.icon
                  phone-icon
                span.text {{ biz.phone }}

          base-card.description( v-if='biz.description' )
            p( v-html='biz.description' )
        
      section#services
        bf-wrapper 
          bf-flex.centered.heading
            h4 {{ $t('Services Offered:') }}
            select(v-model='category_id' required)
              option(value='') {{ $t('Display All') }}
              option(v-for='c in categories' :value='c.id') {{ c.title }}

          srvs-car( 
            :user='user' 
            :account='account' 
            :merchant='biz' 
            :srvs='services.filter( s => s.category_id == category_id || !category_id )' 
            @select='srv = $event'
          )
      
      section#coupons( v-if='discounts.available' )
        bf-wrapper
          h4 {{ $t('Coupons Offered:') }}
          cps-car( :coupons='coupons' @show='coupon = $event' :merchant='merchant' :visited='!!visits' )

      section#recommend.centered-text( v-if='referrable' )
        bf-wrapper
          bf-button.wide( @click.native='modal.refer = true' )
            template(v-slot:text) {{ $t('Refer Merchant to a Friend') }}
</template>

<script>
  import 'vue-cal/dist/vuecal.css'
  import { db } from '@/main'
  import { Datetime } from 'vue-datetime'
  import SocialButton from '@/components/social-button'
  import BaseCard from '@/components/base-card'
  import QrCode from '@chenfengyuan/vue-qrcode'
  import ReserveDialog from '@/components/reserve-dialog'
  import RsvCar from '@/components/rsv-car'
  import CpsCar from '@/components/carousels/coupons'
  import VueCal from 'vue-cal'
  import SrvsCar from '@/components/carousels/services'
  import ReferForm from '@/components/forms/refer'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'
  import SrvDtls from '@/components/modals/srv-dtls'
  import CpnDtls from '@/components/modals/coupon'

  export default {
    name: 'merchant.view',

    components: {
      Datetime,
      SocialButton,
      BaseCard,
      QrCode,
      ReserveDialog,
      VueCal,
      RsvCar,
      SrvsCar,
      SrvDtls,
      ReferForm,
      BaseModal,
      ModalWrapper,
      CpsCar,
      CpnDtls
    },

    props: {
      user: { type: [null, Object] }, 
      account: {}, 
      biz: {},
      srvs: {}, 
      csts: {}, 
      settings: {}
    },

    data() {
      return {
        referrals: [],
        coupons: [],
        coupon: false,
        merchant: {}, // account doc belonging to the owner/merchant of the biz
        services: [],
        service_id: '',
        srv: false,
        datetime: new Date().toISOString(),
        favorites: [],
        categories: [],
        category_id: '',
        key: 0,
        show: { reserve: false, service: false, cal: false },
        message: '',
        visits: '(counting...)',
        modal: { refer: false },
        reservations: []
      }
    },
    
    firestore() {
      return {
        services: db.collection( 'services' ).where( 'business_id', '==', this.biz.id ),
        coupons: db.collection( 'coupons' ).where( 'uid', '==', this.biz.user_id ).where( 'status', '==', 'active' ) 
      }
    },

    computed: {
      style() {
        return {
          backgroundImage: this.settings.background == 4 ? `url(${this.settings.uploaded})` : `url(/bgs/${this.settings.background}.jpg)`,
          backgroundColor: this.settings.color  
        }
      },

      ref() {
        return db.collection( 'settings' ).doc( `${this.biz.user_id}->settings` )
      },

      rsvs() {
        return this.reservations.filter( r => r.account_id == this.account.id )
      }, 

      discounts() {
        this.merchant.rewards = this.merchant.rewards || []
        let rewards = Object.values( Object.values( this.merchant.rewards ) ).map( r => r.active ).filter( v => v )
        let available = this.coupons.length || rewards.length
        return { available }
      }, 

      vip(){
        return this.cust && this.cust.length ? this.cust[0].category : ''
      },

      referrable() {
        return !this.referrals.find( r => r.for && r.for.biz && r.for.biz.id == this.$route.params.id )
      },

      favored() {
        return !!this.favorites.filter( favorite => favorite.biz_id === this.biz.id ).length
      },

      status() {
        if ( !this.biz ) return false

        if ( !this.biz.status ) return { available: true , title: 'Unknown' }

        switch( this.biz.status.title ) {
          case 'Available'        : return { available: true , title: 'Available'}
          case 'Be back soon'     : return { available: false, title: 'Be back soon'}
          case 'Be back in'       : return { available: false, title: `Be back in ${this.biz.status.duration} mins` }
          case 'Be back at'       : return { available: false, title: `Be back at ${this.biz.status.time}` }
          case 'On vacation'      : return { available: false, title: `On vacation` }
          case 'On vacation till' : return { available: false, title: `On vacation till ${this.biz.status.till}` }
          default                 : return { available: true , title: 'Available' }
        }
      },

      owner() {
        return this.biz.account_id == this.account.id
      }
    },

    watch: {
      account( curr, prev ) {
        if ( curr.id ) {
          this.$binding( 'favorites', db.collection('favorites').where( 'account_id', '==', curr.id) )
          this.$binding( 'cust', db.collection( 'customers' ).where( 'biz_id', '==', this.$route.params.id ).where( 'account_id', '==', curr.id ) )
        } 
      }
    },

    methods: {
      notify(message) {
        this.message = message
      },

      favor() {
        if ( this.account.id == this.merchant.id ) return false

        if ( this.favored ) db.collection('favorites').doc(
          this.favorites.find( favorite => favorite.biz_id === this.biz.id ).id
        ).delete()
        
        else db.collection('favorites').doc( `${this.account.id}->${this.biz.id}` ).set({
          biz_id: this.biz.id,
          account_id: this.account.id
        })
      },

      reserve() {
        this.service_id = this.srv.id
        this.srv = false
        if ( !this.account.id && !this.user ) {
          this.message = 'You must be signed in to make a reservation.  Redirecting now...'
          setTimeout( () => this.$router.push('/sign-in'), 3200 )
        }
        else
          if ( !this.service_id ) this.message = 'Please select a service to make a reservation'
          else this.show.reserve = true
      },

      service_details(i=0) {
        this.srv = this.srvs[i]
        this.service_id = this.srv.id
        this.show.service = true
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #default-layout
    background-size cover
    
  .unavailable
    height calc( 100vh - var(--height-merchant-nav) - 24px )
    display flex
    text-align center
    align-items center

  section
    padding 10px 0

  #merchant
    .bf-wrapper
      display grid
      grid-template-columns 2fr 1fr
      grid-gap 20px
      @media( max-width: 800px )
        grid-template-columns 1fr
      .name
        display flex
        justify-content space-between
        padding 20px
        .bf-flex
          align-items stretch
          position relative
          height 64px
          .logo
            height 100%
          .title
            margin 0 16px
            align-items flex-start
            .availability
              margin-top auto
          h5
            display flex
            align-items center
          .availability
            margin-top 16px
            background rgb( 100 150 100 )
            color white
            padding 4px 16px
            border-radius 16px
            &.not-available
              background rgb( 160 160 160 )

      .contact
        padding 16px 24px

      .description
        padding 20px
        
    .fav-btn
      text-align center
      .icon
        font-size 2.21em
      .vip
        margin-top 25px
      &.fav .icon
        color red
      .text
        display none
        @media(min-width: 480px)
          display block

    .contact
      .bf-flex
        align-items center
        margin 4px 0
      .icon
        font-size 1.2em
        margin-right 12px
        color rgb( 128 128 128 )
      .text
        font-size .88em
      .web, .send-device
        .text
          color rgb(0 200 255)
    
    .description
      grid-column 1 / -1
      white-space pre-line

  #visits
    margin 4px 0 8px 0
    background orange
    .heading
      align-items baseline
      margin-bottom 10px
      span
        margin-left 16px
        color white

  #coupons
    background rgb( 240 240 240 )
    h4
      margin-bottom 32px

  #merchant-cal-dialog
    #merchant-cal
      margin-top 24px

  #srv-dtls-dialog
    .rsv-btn
      padding 24px 16px
      text-align center
    .beta-note
      margin-top 12px

  #reserve-dialog
    .calendar
      margin-top 16px
      padding 8px

  #services
    > *
      margin-top 16px
      &:first-child
        margin-top 0
    .heading
      text-align center
      justify-content flex-start
      margin-bottom 24px
    .icon
      margin-left auto
      font-size 2.4em
    select
      width auto
      border 1px solid rgba( 0 0 0 .25 )
      border-radius 16px
      padding 6px 16px
      margin-left 24px
</style>
